import React from 'react';
import { Modal, Typography, Divider, Row, Col, Card, Tag } from 'antd';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

const DetailsModal = ({ isVisible, onClose, selectedProduct }) => {
  return (
    <Modal
      title="Detalii Produs"
      open={isVisible}
      onCancel={onClose}
      footer={null}
    >
      {selectedProduct && (
        <div>
          <Title level={5}>{selectedProduct.product?.denumire}</Title>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Text strong>SKU:</Text>
              <br />
              <Text>{selectedProduct.product?.sku_intern}</Text>
            </Col>
            <Col span={12}>
              <Text strong>Status:</Text>
              <br />
              <Tag color={
                selectedProduct.product_status_id === 1 ? 'blue' :
                selectedProduct.product_status_id === 2 ? 'orange' : 'green'
              }>
                {
                  selectedProduct.product_status_id === 1 ? 'În așteptare' :
                  selectedProduct.product_status_id === 2 ? 'În procesare' : 'Confirmat'
                }
              </Tag>
            </Col>
            <Col span={12}>
              <Text strong>Preț Cumpărare:</Text>
              <br />
              <Text>{selectedProduct.bought_price} MDL</Text>
            </Col>
            <Col span={12}>
              <Text strong>Preț Vânzare:</Text>
              <br />
              <Text>{selectedProduct.sale_price} MDL</Text>
            </Col>
            <Col span={24}>
              <Text strong>Furnizori:</Text>
              <br />
              {selectedProduct.furnizori?.map(furnizor => (
                <Card key={furnizor.id} className="mt-2">
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <Text>Preț: {furnizor.pret} {furnizor.valuta}</Text>
                    </Col>
                    <Col span={12}>
                      <Text>Data verificare: {dayjs(furnizor.data_verificare).format('DD/MM/YYYY')}</Text>
                    </Col>
                  </Row>
                </Card>
              ))}
            </Col>
          </Row>
        </div>
      )}
    </Modal>
  );
};

export default DetailsModal; 